import { render, staticRenderFns } from "./filter-bar.vue?vue&type=template&id=521b74ba"
import script from "./filter-bar.vue?vue&type=script&lang=ts"
export * from "./filter-bar.vue?vue&type=script&lang=ts"
import style0 from "./filter-bar.vue?vue&type=style&index=0&id=521b74ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconLogo: require('/vercel/path0/components/ui/icon/logo.vue').default,FilterAddress: require('/vercel/path0/components/filter/address.vue').default,FilterCalendar: require('/vercel/path0/components/filter/calendar.vue').default,FilterPerson: require('/vercel/path0/components/filter/person.vue').default,UiIconSearch: require('/vercel/path0/components/ui/icon/search.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default})
